import { ChangeDetectionStrategy, Component, ErrorHandler, EventEmitter, Input, OnInit, Output, signal } from '@angular/core'

import { RaporttiType } from '@lemon/core-firebase/model/reports-shared'
import { Kirjanpitotili, RaporttiBruttoTuloslaskelmaData, RaporttiBruttoTuloslaskelmaDataResponse, RaporttiBruttoTuloslaskelmarivi, RaporttiRequest } from 'app/_jaettu-lemonator/model/kirjanpito'
import { BehaviorSubject, Observable, combineLatest, of } from 'rxjs'
import { startWith, switchMap, tap } from 'rxjs/operators'
import { KlikattuKirjaus, RaporttienHakuvaihtoehdot } from '../raportit.component'

import { Timestamp } from '@lemon/core/model/common'
import { AsiakasService } from 'app/_angular/service/asiakas/asiakas.service'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'

@Component({
  selector: '[app-kirjanpito-tuloslaskelma-brutto]',
  templateUrl: './tuloslaskelma-brutto.component.html',
  styleUrls: ['./tuloslaskelma-brutto.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KirjanpitoRaportitTuloslaskelmaBruttoComponent implements OnInit {
  @Input() hakuvaihtoehdotObservable: Observable<RaporttienHakuvaihtoehdot>
  @Input() tilitMapObservable: Observable<Map<string, Kirjanpitotili>>
  @Input() paivitaArvotHiljaisestiSubject: BehaviorSubject<number>

  @Output() kirjaustaKlikattiin: EventEmitter<KlikattuKirjaus> = new EventEmitter()

  readonly lastSucessfullyUpdated = signal<Timestamp>(undefined)

  readonly lataa = signal(true)
  tuloslaskelmanDataObservable: Observable<RaporttiBruttoTuloslaskelmaData>

  constructor(
    private _firebase: FirebaseLemonator,
    private _asiakasService: AsiakasService,
    private _timestampService: TimestampService,
    private _errorHandler: ErrorHandler,
  ) {}

  ngOnInit() {
    this.tuloslaskelmanDataObservable = combineLatest([
      this._asiakasService.nykyinenAsiakasObservable,
      this.hakuvaihtoehdotObservable.pipe(
        tap(() => {
          this.lataa.set(true)
        }),
      ),
      this.paivitaArvotHiljaisestiSubject,
    ]).pipe(
      switchMap(([asiakas, hakuvaihtoehdot, paivita]) => {
        if (!hakuvaihtoehdot?.alkaa || !hakuvaihtoehdot?.loppuu || !asiakas) {
          return of<RaporttiBruttoTuloslaskelmaData>(null)
        }

        const haku: RaporttiRequest = {
          a: asiakas.avain,
          k: 'fi',
          w: RaporttiType.TULOS_BRUTTO,
          s: hakuvaihtoehdot.alkaa,
          e: hakuvaihtoehdot.loppuu,
          datasource: hakuvaihtoehdot.datasource,
        }
        // if (hakuvaihtoehdot.tilista) { haku.b = hakuvaihtoehdot.tilista }
        // if (hakuvaihtoehdot.tiliin) { haku.c = hakuvaihtoehdot.tiliin }
        // if (hakuvaihtoehdot.vapaasanahaku?.trim()) { haku.t = hakuvaihtoehdot.vapaasanahaku.trim() }
        if (hakuvaihtoehdot.projekti) {
          haku.p = hakuvaihtoehdot.projekti
        }

        return this._firebase
          .functionsCall<RaporttiRequest, RaporttiBruttoTuloslaskelmaDataResponse>('kirjanpitoRaportitData', haku)
          .then(res => {
            if (res.e) {
              throw new Error(res.e)
            }
            this.lastSucessfullyUpdated.set(this._timestampService.now())
            this.lataa.set(false)
            return res.data
          })
          .catch(err => {
            console.error('Failed to fetch report data', err)
            this._errorHandler.handleError(err)
          })
      }),
      startWith<RaporttiBruttoTuloslaskelmaData>({
        c1Header: null,
        c2Header: null,
        c: 'c2',
        data: [],
      }),
    )
  }

  focusOnKirjaus(kirjausnumero: string) {
    this.kirjaustaKlikattiin.emit({ kirjausnumero: kirjausnumero })
  }

  trackAccountRowByAccountNumberFn(index: number, item: RaporttiBruttoTuloslaskelmarivi) {
    return index
  }
}
